// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/affiliate_network.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ArchiveAffiliateNetworkRequest, ArchiveAffiliateNetworkResponse, CreateAffiliateNetworkRequest, CreateAffiliateNetworkResponse, GetAffiliateNetworkRequest, GetAffiliateNetworkResponse, ListAffiliateNetworksRequest, ListAffiliateNetworksResponse, ListNetworkNumbersRequest, ListNetworkNumbersResponse, ListNetworkStatusesRequest, ListNetworkStatusesResponse, UpdateAffiliateNetworkRequest, UpdateAffiliateNetworkResponse } from "./affiliate_network_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.AffiliateNetworkService
 */
export const AffiliateNetworkService = {
  typeName: "tracker.v1.AffiliateNetworkService",
  methods: {
    /**
     * @generated from rpc tracker.v1.AffiliateNetworkService.ListAffiliateNetworks
     */
    listAffiliateNetworks: {
      name: "ListAffiliateNetworks",
      I: ListAffiliateNetworksRequest,
      O: ListAffiliateNetworksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.AffiliateNetworkService.GetAffiliateNetwork
     */
    getAffiliateNetwork: {
      name: "GetAffiliateNetwork",
      I: GetAffiliateNetworkRequest,
      O: GetAffiliateNetworkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.AffiliateNetworkService.CreateAffiliateNetwork
     */
    createAffiliateNetwork: {
      name: "CreateAffiliateNetwork",
      I: CreateAffiliateNetworkRequest,
      O: CreateAffiliateNetworkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.AffiliateNetworkService.UpdateAffiliateNetwork
     */
    updateAffiliateNetwork: {
      name: "UpdateAffiliateNetwork",
      I: UpdateAffiliateNetworkRequest,
      O: UpdateAffiliateNetworkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.AffiliateNetworkService.ArchiveAffiliateNetwork
     */
    archiveAffiliateNetwork: {
      name: "ArchiveAffiliateNetwork",
      I: ArchiveAffiliateNetworkRequest,
      O: ArchiveAffiliateNetworkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ListNetworkStatuses is the partner card's status table: every word the
     * partner sent (from the postback journal) or the mapping names, with what
     * it means now. Saving the table is UpdateAffiliateNetwork with
     * conversion_mapping.statuses; words that were unknown are then replayed.
     *
     * @generated from rpc tracker.v1.AffiliateNetworkService.ListNetworkStatuses
     */
    listNetworkStatuses: {
      name: "ListNetworkStatuses",
      I: ListNetworkStatusesRequest,
      O: ListNetworkStatusesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.AffiliateNetworkService.ListNetworkNumbers
     */
    listNetworkNumbers: {
      name: "ListNetworkNumbers",
      I: ListNetworkNumbersRequest,
      O: ListNetworkNumbersResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

